module.exports = __webpack_public_path__ + "media/images/patent/y_6-f58e2305c002260852502a33e3dd837c.jpg";